"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var lang_service_1 = __importDefault(require("../../services/lang.service"));
;
var EpisodeList = (function (_super) {
    __extends(EpisodeList, _super);
    function EpisodeList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EpisodeList.prototype.render = function () {
        var _a = this.props, comic = _a.comic, currentEpisode = _a.currentEpisode, onEpisodeClick = _a.onEpisodeClick;
        var episodes = comic.episodes;
        var getLabel = lang_service_1.default.getLabel;
        return (react_1.default.createElement("div", { className: "episode-list" },
            react_1.default.createElement("div", { className: "episode-list__side-info-container" },
                react_1.default.createElement("div", { className: "episode-list__side-info" },
                    react_1.default.createElement("div", { className: "episode-list__side-info-content" },
                        react_1.default.createElement("img", { className: "episode-list__comic-title", src: comic.media.title }),
                        comic.isOneShot
                            ? react_1.default.createElement("p", { className: "episode-list__about" }, getLabel(comic.about))
                            : (react_1.default.createElement(react_1.Fragment, null,
                                react_1.default.createElement("p", { className: "episode-list__now-reading" }, getLabel('nowReading')),
                                react_1.default.createElement("h1", { className: "episode-list__episode-title" },
                                    currentEpisode.sequenceCode,
                                    ": ",
                                    getLabel(currentEpisode.title)),
                                react_1.default.createElement("p", { className: "episode-list__about" }, getLabel(currentEpisode.about))))))),
            react_1.default.createElement("div", { className: "episode-list__episodes-container" },
                react_1.default.createElement("div", { className: "episode-list__episodes" }, (!comic.isOneShot && episodes) &&
                    episodes.map(function (episode) { return (react_1.default.createElement("article", { className: "episode-list__item-container", key: episode.id, onClick: function () { return onEpisodeClick(episode); } },
                        react_1.default.createElement("div", { className: "episode-list__item" },
                            react_1.default.createElement("div", { className: "episode-list__item-img", style: {
                                    backgroundImage: "url(\"".concat(episode.media.coverThumb, "\")"),
                                } }),
                            react_1.default.createElement("div", { className: "episode-list__item-content" },
                                react_1.default.createElement("h1", { className: "episode-list__item-title" },
                                    episode.sequenceCode,
                                    ": ",
                                    getLabel(episode.title)),
                                react_1.default.createElement("p", { className: "episode-list__summary" }, getLabel(episode.about)))))); })))));
    };
    return EpisodeList;
}(react_1.Component));
exports.default = EpisodeList;
